export const disableSameOriginRequests = 'disableSameOriginRequests';
